import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetLocatorResponse } from '../../../../shared/types/routes/internalTools/malwareReport';

/**
 * Generate the query key for fetching a locator.
 */
export const getLocatorQueryKey = (
  locator: string,
): QueryKey => ['locators', 'internal-tools', locator];

/**
 * Fetch locator by exact match.
 */
export function fetchLocator(locator: string) {
  return get<GetLocatorResponse>(`/api/internal-tools/locator/${nuc(locator)}`, false);
}

/**
 * Hook to fetch a locator by exact match
 * @param locator - The exact locator string to fetch
 * @returns A query for the locator
 */
export default function useGetLocator(locator: string) {
  const trimmedLocator = locator.trim();
  const isEnabled = trimmedLocator.length >= 2;
  const normalizedLocator = nuc(trimmedLocator);

  return useQuery<GetLocatorResponse>({
    queryKey: getLocatorQueryKey(normalizedLocator),
    queryFn: () => fetchLocator(normalizedLocator),
    enabled: isEnabled,
  });
}
